import React, { useEffect, useContext, useState } from "react";
import "./Forfiet.css"; // Import CSS for styling
import "../src/styles/font.css";
import { ScreenContext } from "./App";

import forfietPanel from "./Assets/Images/GameBoard/Forfiet/ForfietPanel.png";

import quitBtn from "./Assets/Images/GameBoard/Forfiet/QuitBtn.png";
import continueBtn from "./Assets/Images/GameBoard/Forfiet/ContinueBtn.png";

let handleForfietZIndexChangeExport;

const ForFiet = ({ isVisible, onClose }) => {
  //console.log('Battle Screen Loaded');

  const [zIndex, setZIndex] = useState(-99); // Initial z-index value
  const [imageIndex, setImageIndex] = useState(0);

  const handleScreenChange = useContext(ScreenContext);

  //====================================>
  //Function to Render FortfietScreen
  //====================================>
  const handleZIndexChange = (isAutoPlayDice) => {
    console.log(`Is Auto Play Dice ====> ${isAutoPlayDice}`);
    // Change the z-index value
    setZIndex((prevZIndex) => (prevZIndex === 99 ? -99 : 99));
  };

  const handleForitfy = () => {
    handleScreenChange("Home");
  };

  handleForfietZIndexChangeExport = handleZIndexChange;

  return (
    <div
      className={`forfiet-screen`}
      style={{ zIndex, visibility: zIndex === -99 ? "hidden" : "visible" }}
    >
      <div className="forfeit-panel-wrapper">
        <div className="forfeit-panel-container">
          <img
            src={forfietPanel}
            alt="forfeitScreenPanel"
            className="forfeit-panel"
          />

          <div className="forfeit-title">FORFEIT</div>

          <div className="forfeit-desc">
            Are you sure you want to forfeit the game?
          </div>
        </div>
        <div className="forfeit-buttondiv">
          <div style={{width:"40%"}}>
            <img
              src={quitBtn}
              alt="Quit Button"
              style={{width:"100%"}}
              onClick={handleForitfy}
            />
          </div>
          <div style={{width:"40%"}}>
            <img
              src={continueBtn}
              style={{width:"100%"}}
              alt="Continue Button"
              onClick={handleZIndexChange}
            />
          </div>
        </div>

        {/* <div
          className="image-container"
          style={{ position: "absolute", left: "20.5%", top: "105%" }}
        >
          <img
            src={quitBtn}
            alt="Quit Button"
            className="image"
            style={{ marginRight: "10px", width: "31%", height: "auto" }}
            onClick={handleForitfy}
          />
          <img
            src={continueBtn}
            alt="Continue Button"
            className="image"
            style={{ width: "31%", height: "auto" }}
            onClick={handleZIndexChange}
          />
        </div> */}
      </div>
    </div>
  );
};

export { handleForfietZIndexChangeExport };

export default ForFiet;
